import { cn } from '@/lib/utils';

/**
 * A placeholder shaped like the thing that is coming.
 *
 * A spinner in the middle of an empty page says "wait"; a skeleton says "here
 * is what you are waiting for", which is what stops a slow run sheet feeling
 * broken on a bad connection — and this app's connection is bad by definition.
 * Marked aria-hidden and paired with a live region by the caller, so a screen
 * reader hears "Loading" once rather than a wall of empty boxes.
 */
export function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-lg bg-muted motion-reduce:animate-none', className)}
      {...props}
    />
  );
}

/** Announces the wait once, for anyone who cannot see the skeletons. */
export function LoadingAnnouncer({ label = 'Loading' }: { label?: string }) {
  return (
    <span role="status" aria-live="polite" className="sr-only-text">
      {label}
    </span>
  );
}
